import { render } from "./totalContacts.vue?vue&type=template&id=7a3a3ed6"
import script from "./totalContacts.vue?vue&type=script&lang=js"
export * from "./totalContacts.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/appitoc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__